export interface XHRResponse {
  data: {
    has_results: boolean;
    total_pages: number;
    next_page: number | null;
    load_more: boolean;
    page: number;
    posts_html: string;
  };
}

class XHRRequest {
  #searchParams: any[] = [];

  fetch(opts: {
    url: string;
    data: Record<string, any>;
    onSuccess?: (response: XHRResponse) => void;
    onError?: (error: unknown) => void;
  }) {
    // Build params
    const data = { data: opts.data };
    this.#searchParams = [];
    const params = this.formatParams(data);
    const request = new XMLHttpRequest();
    request.open("POST", opts.url, true);
    request.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
    request.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    request.send(params);
    request.onreadystatechange = () => {
      if (request.readyState === 4) {
        if (request.status === 200) {
          try {
            const xhr = JSON.parse(request.response) as XHRResponse;
            if (opts.onSuccess) {
              opts.onSuccess(xhr);
            }
          } catch (error) {
            opts.onError?.(error);
          }
        } else {
          opts.onError?.({ status: request.status, response: request.response });
        }
      }
    };

    request.onerror = () => {
      opts.onError?.({ status: request.status, response: request.response, type: "network" });
    };
  }

  reset() {
    this.#searchParams = [];
  }

  formatParams(a: Record<string, any>[] | Record<string, any>) {
    let prefix: string;
    let name: string;
    let spacePattern = /%20/g;
    let output: string;

    if (Array.isArray(a)) {
      for (name in a) {
        this.addParam(name, a[name]);
      }
    } else {
      for (prefix in a) {
        this.buildParams(prefix, a[prefix]);
      }
    }
    output = this.#searchParams.join("&").replace(spacePattern, "+");
    return output;
  }

  addParam(key: string, value: Function | string | number | boolean | null) {
    const normalizedValue = typeof value == "function" ? value() : value === null ? "" : value;
    this.#searchParams[this.#searchParams.length] =
      encodeURIComponent(key) + "=" + encodeURIComponent(normalizedValue);
  }

  buildParams(prefix: string, obj: any) {
    let name: string;
    const rbracketPattern = /\[\]$/;

    if (Array.isArray(obj)) {
      for (const [index, param] of obj.entries()) {
        if (rbracketPattern.test(prefix)) {
          this.addParam(prefix, param);
        } else {
          this.buildParams(prefix + "[" + (typeof param === "object" ? index : "") + "]", param);
        }
      }
    } else if (typeof obj == "object" && obj !== null) {
      // Serialize object item.
      for (name in obj) {
        this.buildParams(prefix + "[" + name + "]", obj[name]);
      }
    } else {
      // Serialize scalar item.
      this.addParam(prefix, obj);
    }
  }
}

export default new XHRRequest();
